import CONSTANTS from '../../constants/constants'
import { getDaysInMonth } from 'date-fns'
const BANK = CONSTANTS.banks
const BANK_CODE = CONSTANTS.bankCode

export const getBankFullNameByBankCode = (bankCode) => {
  const bankName = Object.keys(BANK_CODE).find((key) => BANK_CODE[key] === bankCode)
  return BANK[bankName]
}

export const getBankFullNameByBankName = (bankName) => {
  return BANK[bankName]
}

export const getTHBirthDay = (birthDay) =>
  new Date(birthDay).toLocaleDateString('th-TH', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })

export const validateNumberOnly = (input) => {
  return input.match(/^[0-9]+$/) || input === '' || input === '0'
}

export const PATTERNS = {
  TEXT: /^[\u0E01-\u0E3E\u0E40-\u0E4F\u0E5A-\u0E5Ba-zA-Z0-9.]+$/,
  NUMBER: /^[0-9]+$/,
  ALPHANUMERIC: /^[\u0E01-\u0E3E\u0E40-\u0E4F\u0E5A-\u0E5Ba-zA-Z0-9]+$/,
  TEXT_WITH_NUMBER: /^[\u0E01-\u0E3E\u0E40-\u0E4F\u0E5A-\u0E5Ba-zA-Z0-9. ]+$/,
  ENGLISH_WITH_NUMBER: /^[a-zA-Z0-9]+$/,
}

export const getDays = (month, year, isThai = false) => {
  let allDays = []
  const limitDay = getDaysInMonth(new Date(year - (isThai ? 543 : 0), month - 1))
  for (let i = 1; i <= limitDay; i++) {
    allDays.push(i)
  }
  return allDays
}

export const getYears = (isThai = false) => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - 100
  const years = []
  for (let i = startYear; i <= currentYear; i++) {
    years.push(i + (isThai ? 543 : 0))
  }
  return years
}

export const getFutureYears = (isThai = false) => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear
  const years = []
  for (let i = startYear; i <= currentYear + 100; i++) {
    years.push(i + (isThai ? 543 : 0))
  }
  return years
}
